<template>
  <div class="home">
    <div class="jumbotron"></div>
    <div class="members">
      <img
        class="members-image"
        src="@/assets/img-2-members.png"
        srcset="@/assets/img-2-members@2x.png 2x, @/assets/img-2-members@3x.png 3x"
        alt="투이지랩스 멤버"
      >
    </div>
    <footer>
      <div class="copyright">© 2EASY Labs.</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style scoped>
.home {
  margin-left: auto;
  margin-right: auto;
}
.jumbotron {
  text-align: center;
  height: 1396px;
  max-width: 100%;
  background: url("../assets/img-1-main@3x.png");
  background-position: 50% 0;
  background-image: image-set(
    "../assets/img-1-main@2x.png" 2x,
    "../assets/img-1-main@3x.png" 3x
  );
  background-repeat: no-repeat;
  background-size: cover;
}
.members {
  text-align: center;
  padding-top: 120px;
  padding-bottom: 160px;
}
.members-image {
  width: 690px;
  height: 195px;
}
footer {
  width: 100%;
  height: 133px;
  background-color: #fafbfb;
  text-align: center;
  padding-top: 40px;
}
.copyright {
  font-size: 12px;
  color: #333333;
}
</style>

